exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{box-sizing:border-box}body{margin:0;background-color:#f2f3f7;height:100%}.form-container{padding:0;margin-top:3.875rem;height:auto}@media (min-width:575px){.form-container{padding:2rem}}", ""]);

// exports
